export enum WhatsappDisplayNameStatus {
  APPROVED = "APPROVED",
  AVAILABLE_WITHOUT_REVIEW = "AVAILABLE_WITHOUT_REVIEW",
  DECLINED = "DECLINED",
  EXPIRED = "EXPIRED",
  PENDING_REVIEW = "PENDING_REVIEW",
  NONE = "NONE",
}
